import QRCode from 'qrcode'
import { useEffect, useState } from 'react'

export function QrCode({ value, size = 320, label }: { value: string; size?: number; label: string }) {
  const [rendered, setRendered] = useState<{ src: string; value: string }>()
  const [error, setError] = useState(false)
  useEffect(() => {
    let active = true
    QRCode.toDataURL(value, { width: size, margin: 2, errorCorrectionLevel: 'M', color: { dark: '#07111a', light: '#ffffff' } })
      .then((url) => { if (active) { setRendered({ src: url, value }); setError(false) } })
      .catch(() => { if (active) setError(true) })
    return () => { active = false }
  }, [value, size])
  return <>{rendered ? <img className="qr" src={rendered.src} data-qr-value={rendered.value} width={size} height={size} alt={label} /> : <div className="qr qr--loading" aria-label="Generando código QR" />}{error && <small role="status">No se pudo actualizar la imagen QR; esperando el siguiente código.</small>}</>
}
